import { Box, Chip, Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import EdicaoProduto from './EdicaoProduto'
import LoteProduto from './loteProduto'
import PrimeTable from '../../../components/PrimeTable'
import EstoqueIndicator from './EstoqueIndicator'

const Produto = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dadosProduto, setDadosProduto] = useState(null)
  const [dadosLote, setDadosLote] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const handleRemove = useCallback((dados) => {
    metodoPrograma('exclui', { idProduto: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDadosProduto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela(tela === 'opcoesLote' ? 'opcoes' : 'lista')
    tela !== 'opcoesLote' && setDadosProduto([])
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Grid>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
            <Tooltip title="Adicionar Lote">
              <IconButton onClick={() => setTela('opcoesLote')}>
                <MdAdd />
              </IconButton>
            </Tooltip>
          </Grid>,
        )
        break
      case 'opcoesLote':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break

      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlProduto" ferramentas={ferramentas}>
      <div style={{ display: tela === 'lista' ? 'block' : 'none' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlProduto"
              action="lista"
              rows={10}
              habSearch
              colStyle={[
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                { textAlign: 'center' },
              ]}
              head={[
                'Código',
                'Produto',
                'Via de Acesso',
                'Estoque Mínimo',
                'Controlado',
                'Exclusão',
                'Valor Venda',
                'Estoque',
              ]}
              line={(item) => [
                item[1],
                item[2],
                '',
                item[6],
                item[4] === 'S' ? 'Sim' : 'Não',
                item[8],
                item[5],
                <EstoqueIndicator
                  key={item[1]}
                  estoque={Number(item[14])}
                  minimo={Number(item[6])}
                />,
              ]}
              columnOptions={[
                {
                  alias: 2,
                  customJsx: ({ linhaOriginal }) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                      {(linhaOriginal?.[10] || []).map((via) => (
                        <Chip
                          key={via[0]?.[0]}
                          label={via[1]?.toUpperCase()}
                          size="small"
                          sx={{
                            color: '#e3f2fd',
                            bgcolor: '#1976d2',
                            height: 18,
                            fontSize: '10px',
                            fontWeight: 600,
                            '& .MuiChip-label': { px: '6px' },
                          }}
                        />
                      ))}
                    </Box>
                  ),
                },
              ]}
              collumnsDateHour={[5]}
              collumnsCurrency={[6]}
              onRowSelect={handleClick}
              onDelete={{ index: 8, action: handleRemove }}
              refresh={refresh}
            />
          </Grid>
        </Grid>
      </div>

      {tela === 'opcoes' && (
        <EdicaoProduto
          {...{
            dadosProduto,
            voltar,
            setTela,
            dadosLote,
            setDadosLote,
            setRefresh,
          }}
        />
      )}
      {tela === 'opcoesLote' && (
        <LoteProduto
          {...{
            idProduto: dadosProduto?.[0],
            tela,
            setTela,
            dadosLote,
            setDadosLote,
          }}
        />
      )}
    </Programa>
  )
}

export default Produto
